import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export interface User {
  userName: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationServiceService {
  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }
  

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  login(user: User) {
    if (user.userName !== '') {
      this.loggedIn.next(true);
      this.router.navigate(['/']);
    }
  }

  logout() {
    this.loggedIn.next(false);
    this.router.navigate(['/']);
  }
}